import { BaseDate } from '@otas/utils/custom-components/panchang-calendar/kollavarsham/base-date';
import { MathHelper } from '@otas/utils/custom-components/panchang-calendar/kollavarsham/math-helper';
import { KollavarshamDate } from '@otas/utils/custom-components/panchang-calendar/kollavarsham/kolla-varsham-date';

export class SakaDate extends BaseDate {
    kaliYear = null;
    adhimasa = null;
    fractionalTithi = null;
    sunriseHour = null;
    sunriseMinute = null;
    originalAhargana = null;
    constructor(public year = 1, public month = 1, tithi = 1, public paksa = 'Suklapaksa') {

        super(year, month, tithi);
        this.paksa = paksa === 'Krsnapaksa' ? paksa : 'Suklapaksa';

    }
    get sakaYear() {
        return this.year;
    }
    get tithi() {
        return this.date;
    }
    get vikramaYear() {
        return this.year + 135;
    }
    get naksatraName() {
        return this.naksatra.saka;
    }
    get masaName() {
        return SakaDate.getMasaName(this.month).saka;
    }
    generateKollavarshamDate() {
        // TODO: Add unit tests
        const malayalaMasa = (this.sauraMasa - 4 + 12) % 12;

        // Sewell p.45 - https://archive.org/stream/indiancalendarwi00sewerich#page/45/mode/1up
        const malayalamYear = this.year - 747 + MathHelper.truncate((this.month - malayalaMasa + 12) / 12);

        const kollavarshamDate = new KollavarshamDate(malayalamYear, malayalaMasa + 1, this.sauraDivasa);

        kollavarshamDate.gregorianDate = this.gregorianDate;
        kollavarshamDate.julianDay = this.julianDay;

        kollavarshamDate.ahargana = this.ahargana;
        kollavarshamDate.sauraMasa = this.sauraMasa;
        kollavarshamDate.sauraDivasa = this.sauraDivasa;
        kollavarshamDate.naksatra = this.naksatra;

        // TODO: As fail-Safe for getting any other properties from the SakaDate, store a copy here directly
        // kollavarshamDate.sakaDate = this;
        // console.log(kollavarshamDate);

        return kollavarshamDate;
    }

    toString() {
        return `${super.toString()} ${this.paksa}`;
    }

}
